import React, { useState } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import userService from "../services/user";
import keys from "../store/keys";

function ChangePassword({ session, setKey, ...props }) {

	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [repeatPassword, setRepeatPassword] = useState("");
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [redirectTo, setRedirectTo] = useState(null);

	const handleSubmit = e => {
		e.preventDefault();
		
		setErrorMessage('');
		setSuccessMessage("");

		if (!newPassword || !repeatPassword || !currentPassword) {
			setErrorMessage(`Please provide all fields.`);
			return;
		}

		if (newPassword !== repeatPassword) {
			setErrorMessage(`New password did not match.`);
			return;
		}

		setKey(keys.isLoading, true);
		userService.updatePassword(session.token, currentPassword, newPassword)
			.then(result => {
				if (result.error) {
					setErrorMessage(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				setKey(keys.isLoading, false);
				setErrorMessage('');
				setSuccessMessage(`Password updated successfully! Use new password to login next time.`);
			});
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<div className="container change-password">
				<p className="cart-title">Update your Password</p>
				<div className="row">
					<div className="col-lg-6">
						<div className="mb-3">
							<label htmlFor="txtPassword0" className="form-label">
								Current Password
							</label>
							<input
								className="form-control shadow-none"
								type="password"
								placeholder="*******"
								required="required"
								onBlur={e => setErrorMessage(``)}
								id="txtPassword0"
								autoComplete="new-password"
								value={currentPassword}
								onChange={e => setCurrentPassword(e.target.value)}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-6">
						<div className="mb-3">
							<label htmlFor="txtPassword" className="form-label">
								New Password
							</label>
							<input
								className="form-control shadow-none"
								type="password"
								placeholder="*******"
								required="required"
								onBlur={e => setErrorMessage(``)}
								id="txtPassword"
								autoComplete="new-password"
								value={newPassword}
								onChange={e => setNewPassword(e.target.value)}
							/>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="mb-3">
							<label htmlFor="txtPassword2" className="form-label">
								Repeat Password
							</label>
							<input
								className="form-control shadow-none"
								type="password"
								placeholder="*******"
								required="required"
								onBlur={e => setErrorMessage(``)}
								id="txtPassword2"
								autoComplete="new-password"
								value={repeatPassword}
								onChange={e => setRepeatPassword(e.target.value)}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col">
						{errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
						{successMessage && <div className="text-success mb-3">{successMessage}</div>}
					</div>
				</div>
				<div className="row">
					<div className="col-lg-6"></div>
					<div className="col-lg-6 text-end">
						<button
								type="button"
								className="btn btn-dark shadow-none"
								onClick={handleSubmit}
							>
								Save Changes
							</button>
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
